module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_1,75_ccsa_desc_blanco.e250c3b7.png";